/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { EditorHelp as icon } from '../../components/Icons';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Faqs' ),
	description: __( 'Gutenify Faqs.' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'Faqs' ),
		__( 'Faq' ),
		__( 'questions' ),
	],
	example: {
		attributes: {
		},
	},
	attributes,
	edit,
	save,
	// supports: {
	// 	html: false,
	// 	align: [ 'wide', 'full' ],
	// },
};

export { name, category, settings };
